var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{class:_vm.style},[_c('span',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.status)))]),(_vm.isPublished)?_c('span',[_vm._v(": "+_vm._s(_vm._f("date")(_vm.pubDate)))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44aaeba0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PubTag.vue
// module id = gIMq
// module chunks = 1